module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("The Desert King’s Pregnant Bride")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "pdlmsr.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('meta', {
    attrs: {
      "content": "text/html; charset=UTF-8"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "halfTitlePage",
    attrs: {
      "id": "htp01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page05"
    }
  }, [_c('h2', {
    staticClass: "halfTitlePageTitle"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("THE DESERT KING’S PREGNANT BRIDE")])])])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page05"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a5377bb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/desertkingspregnantbridethe_htp01.vue
// module id = 66
// module chunks = 0